export enum TimeOffDateFilters {
  ALL = "All",
  INACTIVE = "Past",
  ACTIVE = "Upcoming",
}

export enum GanttDateFilters {
  ACTIVE = "Upcoming",
}
